import { Route } from "react-router-dom";
import ProtectedRouteV2 from "../routes/ProtectedRouteV2";
import PageTitle from "../components/PageTitle";

// 🖨️ Páginas del módulo QZ Tray
import QzTrayConnectionStatus from "../pages/QzTray/ConnectionStatus";
import QzTrayCertificates from "../pages/QzTray/Certificates";
import QzTraySignature from "../pages/QzTray/Signature";
import QzTrayVerifySignature from "../pages/QzTray/VerifySignature";
import QzTrayPreview from "../pages/QzTray/Preview";
import QzTrayPrintTests from "../pages/QzTray/PrintTests";
import QzTrayConfiguration from "../pages/QzTray/Configuration";
import QzTrayGenerateCertificate from "../pages/QzTray/GenerateCertificate";

/**
 * 🖨️ Rutas del módulo QZ Tray (solo soporte)
 * 
 * Cada vista está protegida con verificación de acceso a nivel backend.
 * Agrupa todas las rutas relacionadas con:
 * - Estado de conexión
 * - Certificados digitales
 * - Firma y previsualización
 * - Pruebas de impresión
 * - Configuración avanzada
 */
const qzTrayRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* 🔹 Estado de conexión */}
    <Route
      path="/hardware/qztray/connection"
      element={
        <>
          <PageTitle title="Estado de Conexión" />
          <QzTrayConnectionStatus />
        </>
      }
    />

    {/* 🔹 Certificados digitales */}
    <Route
      path="/hardware/qztray/certificates"
      element={
        <>
          <PageTitle title="Certificados Digitales" />
          <QzTrayCertificates />
        </>
      }
    />

        {/* 🔹 Generación de certificados */}
    <Route
      path="/hardware/qztray/generate-certificate"
      element={
        <>
          <PageTitle title="Generar Certificado" />
          <QzTrayGenerateCertificate />
        </>
      }
    />

    {/* 🔹 Firma digital */}
    <Route
      path="/hardware/qztray/signature"
      element={
        <>
          <PageTitle title="Firma Digital" />
          <QzTraySignature />
        </>
      }
    />

     {/* 🔹 Verificación de firma digital */}
    <Route
      path="/hardware/qztray/verify"
      element={
        <>
          <PageTitle title="Verificación de Firma" />
          <QzTrayVerifySignature />
        </>
      }
    />

    {/* 🔹 Previsualización */}
    <Route
      path="/hardware/qztray/preview"
      element={
        <>
          <PageTitle title="Previsualización" />
          <QzTrayPreview />
        </>
      }
    />

    {/* 🔹 Pruebas de impresión */}
    <Route
      path="/hardware/qztray/print-tests"
      element={
        <>
          <PageTitle title="Pruebas de Impresión" />
          <QzTrayPrintTests />
        </>
      }
    />

    {/* 🔹 Configuración avanzada */}
    <Route
      path="/hardware/qztray/config"
      element={
        <>
          <PageTitle title="Configuración Avanzada" />
          <QzTrayConfiguration />
        </>
      }
    />
  </Route>
);

export default qzTrayRoutes;
